import _ from 'lodash';
import { FC } from 'react';
import { BrokerSpecificComponentsProps } from 'v3/pages/LandingPage/Default/BannerSection/UserAuth/LoginModal/types.type';
import UserInput from 'v3/common/components/UserInput';
import PortalToTarget from 'v3/common/components/PortalToTarget';
import Button from 'v3/common/components/Button';

const FairInvest: FC<BrokerSpecificComponentsProps> = ({ userConfigs, brokerSpecificHandles }) => {
  const { reDirectPage, updatePartialConfigs, validateClientId, sendOtp, isMobile } = brokerSpecificHandles;

  const {
    clientId,
    password,
    isClientValidated,
    shouldShowApiKey,
    otp,
    apiKey,
    isValidForm,
    selectedBrokerConfig,
    isLoading,
  } = userConfigs;

  const broker = selectedBrokerConfig?.id;

  return (
    <form
      id={`${broker}-form`}
      onSubmit={(e) => {
        e.preventDefault();
        if (isClientValidated) {
          reDirectPage();
        } else {
          validateClientId();
          if (isClientValidated) sendOtp();
        }
      }}
    >
      <UserInput
        autoFocus={!isMobile}
        labelValue="Client Id"
        id={`${broker}-client-id`}
        value={clientId}
        disabled={isClientValidated}
        onHandleChange={(value) => updatePartialConfigs({ clientId: value })}
      />

      {isClientValidated && (
        <UserInput
          labelValue="Password"
          id={`${broker}-password`}
          type="password"
          value={password}
          onHandleChange={(value) => updatePartialConfigs({ password: value })}
        />
      )}

      {shouldShowApiKey && (
        <>
          <UserInput
            labelValue="API Key"
            id={`${broker}-api-key`}
            type="text"
            value={apiKey}
            onHandleChange={(value) => updatePartialConfigs({ apiKey: value })}
          />
          <div className="my-2 alert alert-warning py-1 px-2">
            Please contact FairInvest support to get your API Key.
          </div>
        </>
      )}
      {isClientValidated && (
        <>
          <UserInput
            labelValue="OTP"
            id={`${broker}-otp`}
            value={otp ?? ''}
            onHandleChange={(value) => updatePartialConfigs({ otp: _.toNumber(value) })}
          />
          <button type="button" onClick={() => sendOtp(true)}>
            <i className="fa-regular fa-gear fa-spin" />
            <span> Re-Send OTP ?</span>
          </button>
        </>
      )}

      <PortalToTarget targetClassName="login-modal__footer" allowForWeb>
        <Button form={`${broker}-form`} type="submit" isLoading={isLoading} disabled={!isValidForm}>
          {isClientValidated ? 'Verify And Login' : 'Validate'}
        </Button>
      </PortalToTarget>
    </form>
  );
};

export default FairInvest;
